// extracted by mini-css-extract-plugin
module.exports = {"templates":"RelatedTemplates_templates__m35gP","sectionTitle":"RelatedTemplates_sectionTitle__aZL7s"};